import Layout from "layouts/Layout.vue"
import InnerLayout from "layouts/InnerLayout.vue"

const Home = () => import("components/Home.vue")
const Login = () => import("components/Login.vue")
const Logout = () => import("components/Logout.vue")
const Registration = () => import("components/Registration.vue")
const NotFound = () => import("components/NotFound.vue")
const Forgot = () => import("components/Forgot.vue")
const Reset = () => import("components/Reset.vue")
const Confirm = () => import("components/Confirm.vue")
const WikiArticle = () => import("components/WikiArticle.vue")
const Changelog = () => import("components/Changelog.vue")
const Invoice = () => import("components/Invoice.vue")
const Features = () => import("components/Features.vue")
const Pricing = () => import("components/Pricing.vue")
const GoTo = () => import("components/GoTo.vue")
const Dashboard = () => import("components/inner/Dashboard.vue")
const Project = () => import("components/inner/Project.vue")
const Projects = () => import("components/inner/Projects.vue")
const Billing = () => import("components/inner/Billing.vue")
const Settings = () => import("components/inner/Settings.vue")
const Plan = () => import("components/inner/Plan.vue")
const ChoosePlan = () => import("components/inner/ChoosePlan.vue")
const Pay = () => import("components/inner/Pay.vue")

export default [
    {
        path: "/",
        name: "Outer",
        redirect: "/",
        component: Layout,
        children: [
            {
                path: "/",
                name: "Home",
                component: Home,
                meta: {
                    title: 'Home'
                },
            },
            {
                path: "/features",
                name: "Features",
                component: Features,
                meta: {
                    title: 'Features'
                },
            },
            {
                path: "/pricing",
                name: "Pricing",
                component: Pricing,
                meta: {
                    title: 'Pricing'
                },
            },
            {
                path: "/changelog",
                name: "Changelog",
                component: Changelog,
                meta: {
                    title: "Changelog — Latest Updates",
                    description: "Cryprum changelog. Latest updates, new features, bug fixes, and improvements to the crypto payment gateway.",
                    keywords: "changelog, updates, release notes, Cryprum updates, new features"
                },
            },
            {
                path: "/help/*",
                name: "WikiArticle",
                component: WikiArticle,
                meta: {
                    title: 'Help'
                },
            },
        ]
    },
    {
        path: "/dashboard",
        name: "Inner",
        redirect: "/dashboard",
        component: InnerLayout,
        children: [
            {
                path: "",
                name: "Dashboard",
                component: Dashboard,
                meta: {
                    title: 'Dashboard'
                },
            },
            {
                path: "/projects",
                name: "Projects",
                component: Projects,
                meta: {
                    title: 'Projects'
                },
            },
            {
                path: "/projects/:id",
                name: "Project",
                component: Project,
                meta: {
                    title: 'Project'
                },
            },
            {
                path: "/billing",
                name: "Billing",
                component: Billing,
                meta: {
                    title: 'Billing'
                },
            },
            {
                path: "/billing/pay",
                name: "Pay",
                component: Pay,
                meta: {
                    title: 'Pay'
                },
            },
            {
                path: "/plan",
                name: "Plan",
                component: Plan,
                meta: {
                    title: 'Plan'
                },
            },
            {
                path: "/plan/choose/:id",
                name: "Choose plan",
                component: ChoosePlan,
                meta: {
                    title: 'Choose plan'
                },
            },
            {
                path: "/settings",
                name: "Settings",
                component: Settings,
                meta: {
                    title: 'Settings'
                },
            },
        ]
    },
    {
        path: "/login",
        name: "Login",
        component: Login,
        meta: {
            title: 'Login'
        },
    },
    {
        path: "/forgot",
        name: "Forgot",
        component: Forgot,
        meta: {
            title: 'Forgot password',
        },
    },
    {
        path: "/reset/:uid/:token",
        name: "Reset",
        component: Reset,
        meta: {
            title: 'Reset password',
        },
    },
    {
        path: "/confirm/:uid/:token",
        name: "Confirm",
        component: Confirm,
        meta: {
            title: 'Confirm'
        },
    },
    {
        path: "/logout",
        name: "Logout",
        component: Logout,
        meta: {
            title: 'Logout'
        },
    },
    {
        path: "/registration",
        name: "Registration",
        component: Registration,
        meta: {
            title: 'Registration'
        },
    },
    {
        path: '/404',
        name: '404',
        component: NotFound,
        meta: {
            title: '404'
        },
    },
    {
        path: "/g/:b64",
        name: "GoTo",
        component: GoTo,
        meta: {
            title: 'GoTo'
        },
    },
    {
        path: '/invoice/:id',
        name: 'Invoice',
        component: Invoice,
        meta: {
            title: 'Invoice'
        },
    },
    {
        path: '*',
        component: NotFound,
        meta: {
            title: '404'
        }
    }
]
